function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { RcCascaderProvider, useCreateCascader } from '../../hooks/cascader';
import { CascaderPanelComp } from '../cascader/components/CascaderPanelComp';
import { CascaderSearch } from '../cascader/components/CascaderSearch';
import { CascaderViewer } from '../cascader/components/CascaderViewer';
export function CascaderPanel(props) {
  var locale = useLocale('cascader.titles');

  var _props$searchable = props.searchable,
      searchable = _props$searchable === void 0 ? false : _props$searchable,
      searchPlaceholder = props.searchPlaceholder,
      renderSearchItem = props.renderSearchItem,
      className = props.className,
      renderItem = props.renderItem,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      onSearchChange = props.onSearchChange,
      value = props.value,
      checkStrategy = props.checkStrategy,
      _props$columnTitles = props.columnTitles,
      columnTitles = _props$columnTitles === void 0 ? locale : _props$columnTitles,
      disabled = props.disabled,
      panelStyle = props.panelStyle,
      panelHeight = props.panelHeight,
      _props$viewer = props.viewer,
      viewer = _props$viewer === void 0 ? true : _props$viewer,
      onDisplayInfoChange = props.onDisplayInfoChange,
      showClearAll = props.showClearAll,
      renderPanelItem = props.renderPanelItem,
      emptyRender = props.emptyRender,
      emptyContent = props.emptyContent,
      extra = _objectWithoutProperties(props, ["searchable", "searchPlaceholder", "renderSearchItem", "className", "renderItem", "onChange", "onValueChange", "onSearchChange", "value", "checkStrategy", "columnTitles", "disabled", "panelStyle", "panelHeight", "viewer", "onDisplayInfoChange", "showClearAll", "renderPanelItem", "emptyRender", "emptyContent"]);

  var onChangeCallback = useRefCallback(onChange);
  var onValueChangeCallback = useRefCallback(onValueChange);
  var onDisplayInfoChangeCallback = useRefCallback(onDisplayInfoChange);
  var onSearchChangeCallback = useRefCallback(onSearchChange);
  var handleChange = useCallback(function (newVal, infos) {
    onChangeCallback(newVal[0]);
    onValueChangeCallback(newVal[0]);
    onDisplayInfoChangeCallback(infos.map(function (_ref) {
      var item = _ref.item,
          values = _ref.values;
      return _objectSpread(_objectSpread({}, item), {}, {
        values: values
      });
    }));
  }, []);

  var _useCreateCascader = useCreateCascader(_objectSpread(_objectSpread({}, extra), {}, {
    particalCheck: true,
    disabled: disabled,
    columnTitles: columnTitles,
    multiple: false,
    independent: checkStrategy === 'independent',
    spread: false,
    onChange: handleChange,
    value: value == null ? [] : [value]
  })),
      cascader = _useCreateCascader.cascader;

  var cls = classnames(usePrefixCls('cascader'), className);
  var innerCls = usePrefixCls('cascader-inner');
  return React.createElement(RcCascaderProvider, {
    cascader: cascader
  }, React.createElement("div", {
    className: cls
  }, React.createElement(CascaderSearch, {
    searchable: searchable,
    renderSearchItem: renderSearchItem,
    searchPlaceholder: searchPlaceholder,
    onSearchChange: onSearchChangeCallback
  }), React.createElement("div", {
    className: innerCls
  }, React.createElement(CascaderPanelComp, {
    renderItem: renderItem,
    emptyRender: emptyRender,
    emptyContent: emptyContent,
    panelStyle: panelStyle,
    panelHeight: panelHeight
  }), viewer && React.createElement(CascaderViewer, {
    renderPanelItem: renderPanelItem,
    panelHeight: panelHeight,
    showClearAll: showClearAll,
    disabled: disabled
  }))));
}